import { DeviceCategory } from './device-category';
import { Organization } from './organization';
import { Tenant } from './tenant';

export class Device {
  serialNumber: string;
  description: string;
  alias: string;
  timezone: string;
  creationAt: number;
  updatedAt: number;
  dateLastValueReported: number;
  technicalDetails: string;
  deviceCategory: DeviceCategory;
  tenant: Tenant;
  organization: Organization;
  uuid: string;
  associationDate: number;
  associationEndDate?: number;
}
